// Language translations
export const translations = {
  id: {
    // Header Navigation
    header: {
      home: 'Beranda',
      about: 'Tentang Kami',
      services: 'Layanan',
      products: 'Produk',
      partners: 'Partner',
      clients: 'Klien',
      contact: 'Hubungi Kami',
    },
    // Hero Section
    hero: {
      badge: 'System Integrator Terpercaya Sejak',
      startConsultation: 'Mulai Konsultasi',
      viewServices: 'Lihat Layanan',
    },
    // Services Section
    services: {
      title: 'Solusi IT Terintegrasi',
      description: 'Menyatukan teknologi, sistem, dan data dalam satu ekosistem terintegrasi untuk mendorong efisiensi dan keunggulan kompetitif bisnis Anda.',
      ourServices: 'Layanan Kami',
      viewFullDetails: 'Lihat Detail Lengkap',
    },
    // Products Section
    products: {
      title: 'Produk Solusi Unggulan',
      ourProducts: 'Produk Kami',
    },
    // Partners Section
    partners: {
      title: 'Partner Teknologi',
      subtitle: 'Partner Kami',
      description: 'Berkolaborasi dengan pemimpin industri teknologi terkemuka untuk memberikan solusi kelas dunia.',
      viewAll: 'Lihat Semua Partner',
    },
    // Clients Section
    clients: {
      ourClients: 'Klien Kami',
      description: 'Kami bangga mendapatkan kesempatan melayani dan berkolaborasi dengan institusi pemerintahan serta korporasi terbaik di Indonesia',
    },
    // Contact Section
    contact: {
      whatsappMessage: 'Halo Seleno, saya tertarik untuk mengetahui lebih lanjut tentang layanan Anda.',
    },
    // ServiceDetail
    serviceDetail: {
      notFound: 'Layanan Tidak Ditemukan',
      backHome: 'Kembali ke Halaman Utama',
      back: 'Kembali',
      featured: 'Layanan Unggulan',
      valueHighlights: 'Sorotan Nilai',
      benefits: 'Manfaat Utama',
      readyToImplement: 'Siap Mewujudkan Transformasi Digital Anda?',
      readyDesc: 'Tim ahli kami hadir untuk merancang dan mengimplementasikan solusi infrastruktur yang presisi serta adaptif bagi pertumbuhan bisnis Anda',
      freeConsultation: 'Konsultasi Gratis',
      featuresOverview: 'Fitur Utama',
      benefitsForBusiness: 'Manfaat untuk Bisnis Anda',
      downloadFullSpec: 'Download Spesifikasi Lengkap',
      pdfNotAvailable: 'PDF Belum Tersedia',
    },
    // ProductDetail
    productDetail: {
      notFoundTitle: 'Produk Tidak Ditemukan',
      notFound: 'Produk tidak ditemukan',
    },
    // Footer
    footer: {
      products: 'Produk',
    },
  },
  en: {
    // Header Navigation
    header: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      products: 'Products',
      partners: 'Partners',
      clients: 'Clients',
      contact: 'Contact Us',
    },
    // Hero Section
    hero: {
      badge: 'Trusted System Integrator Since',
      startConsultation: 'Start Consultation',
      viewServices: 'View Services',
    },
    // Services Section
    services: {
      title: 'Integrated IT Solutions',
      description: 'Unifying technology, systems, and data into a single integrated ecosystem to drive efficiency and your business\'s competitive advantage.',
      ourServices: 'Our Services',
      viewFullDetails: 'View Full Details',
    },
    // Products Section
    products: {
      title: 'Featured Product Solutions',
      ourProducts: 'Our Products',
    },
    // Partners Section
    partners: {
      title: 'Technology Partners',
      subtitle: 'Our Partners',
      description: 'Collaborating with global technology industry leaders to deliver world-class solutions.',
      viewAll: 'View All Partners',
    },
    // Clients Section
    clients: {
      ourClients: 'Our Clients',
      description: 'We are proud to have the opportunity to serve and collaborate with government institutions and top corporations in Indonesia',
    },
    // ServiceDetail
    serviceDetail: {
      notFound: 'Service Not Found',
      backHome: 'Back to Home',
      back: 'Back',
      featured: 'Flagship Services',
      valueHighlights: 'Value Highlights',
      benefits: 'Key Benefits',
      readyToImplement: 'Ready to Realize Your Digital Transformation?',
      readyDesc: 'Our team of experts is here to design and implement precise and adaptive infrastructure solutions for the growth of your business',
      freeConsultation: 'Free Consultation',
      featuresOverview: 'Feature Overview',
      benefitsForBusiness: 'Benefits for Your Business',
      downloadFullSpec: 'Download Full Specifications',
      pdfNotAvailable: 'PDF Not Available',
    },
    // ProductDetail
    productDetail: {
      notFoundTitle: 'Product Not Found',
      notFound: 'Product not found',
    },
    // Contact Section
    contact: {
      whatsappMessage: 'Hello Seleno, I am interested in learning more about your services.',
    },
    // Footer
    footer: {
      products: 'Products',
    },
  },
};

// Helper function to get translated text
export const t = (language, path) => {
  const keys = path.split('.');
  let value = translations[language];

  for (const key of keys) {
    value = value?.[key];
  }

  return value || path;
};


